const carouselItems = [
  {
    title: '暑期档必看大片合集',
    desc: '《星际穿越2》《深海危机》《烈火英雄2》等暑期重磅大片一网打尽，高清画质畅快观影',
    tag: '热门推荐',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20collage%20featuring%20summer%20blockbuster%20film%20posters%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20crimson%20color%20tones%2C%20epic%20scene%20compositions%2C%20movie%20theater%20aesthetic%2C%20clean%20minimal%20design%20with%20bold%20typography%20space&width=800&height=450&seq=carousel-summer-blockbusters&orientation=landscape',
    alt: '暑期档必看大片合集专题',
  },
  {
    title: '国产悬疑剧巅峰推荐',
    desc: '《白夜追凶2》《隐秘的角落》《沉默的真相》等高口碑国产悬疑剧，全程高能无尿点',
    tag: '剧集精选',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20and%20suspenseful%20Chinese%20crime%20drama%20visual%20with%20dark%20moody%20lighting%2C%20film%20noir%20aesthetic%2C%20shadows%20and%20silhouettes%2C%20urban%20nightscape%20background%2C%20warm%20amber%20accents%20on%20dark%20tones%2C%20cinematic%20composition&width=800&height=450&seq=carousel-crime-dramas&orientation=landscape',
    alt: '国产悬疑剧巅峰推荐专题',
  },
  {
    title: '日韩热播剧追番指南',
    desc: '《泪之女王》《财阀家的小儿子》《重启人生》等日韩现象级热剧，中字高清全集追不停',
    tag: '海外剧场',
    img: 'https://readdy.ai/api/search-image?query=Korean%20and%20Japanese%20drama%20series%20visual%20collage%20with%20romantic%20and%20dramatic%20scenes%2C%20soft%20warm%20lighting%2C%20modern%20urban%20settings%2C%20emotional%20character%20moments%2C%20rose%20and%20amber%20color%20palette%2C%20elegant%20cinematic%20style&width=800&height=450&seq=carousel-kdrama-jdrama&orientation=landscape',
    alt: '日韩热播剧追番指南专题',
  },
  {
    title: '高分纪录片深度推荐',
    desc: '《地球脉动III》《蓝色星球III》《舌尖上的中国4》等豆瓣9分以上神级纪录片，涨知识必备',
    tag: '纪录片',
    img: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20visual%20with%20stunning%20landscapes%2C%20wildlife%20photography%2C%20ocean%20scenes%20and%20mountain%20vistas%2C%20rich%20natural%20colors%20with%20warm%20earthy%20tones%2C%20cinematic%20wide%20shots%2C%20inspirational%20and%20educational%20aesthetic&width=800&height=450&seq=carousel-documentaries&orientation=landscape',
    alt: '高分纪录片深度推荐专题',
  },
  {
    title: '热门综艺笑料一锅端',
    desc: '《奔跑吧》《王牌对王牌》《脱口秀大会》等国民综艺，爆笑名场面合集一次看过瘾',
    tag: '综艺专区',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20studio%20lighting%2C%20entertaining%20and%20funny%20atmosphere%2C%20game%20show%20elements%2C%20vibrant%20warm%20colors%20with%20gold%20and%20coral%20accents%2C%20lively%20composition%2C%20celebrity%20entertainment%20vibe&width=800&height=450&seq=carousel-variety-shows&orientation=landscape',
    alt: '热门综艺笑料一锅端专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm font-medium text-primary-500 uppercase tracking-wide mb-2">精选专题</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">精选专题</h2>
          <p className="mt-2 text-sm text-foreground-500">精心策划的影视专题，发现更多好内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-[1100px] mx-auto">
          <div className="sm:col-span-2 lg:col-span-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {carouselItems.map((item, idx) => (
                <div
                  key={idx}
                  className={`group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-300 ${
                    idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
                  }`}
                >
                  <div className={`relative w-full ${idx === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                    <img
                      src={item.img}
                      alt={item.alt}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
                    <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                    <h3 className="text-sm md:text-base font-bold text-background-50 mb-1 line-clamp-1">{item.title}</h3>
                    <p className="text-xs text-background-50/75 line-clamp-2 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}